import React, { Component } from "react";
import { Container, Col, Row } from "react-bootstrap";
import Desplegable from "../../desplegable";
import FormTipoFormacion from "../formularios/form_tipo_formacion";
import $ from "jquery";
import * as utils from "../../../utils.js";

export default class VistaTipoFormacion extends Component {
  constructor(props) {
    super(props);
    this.mostrarTipoFormacion = this.mostrarTipoFormacion.bind(this);
    this.deleteTipoFormacion = this.deleteTipoFormacion.bind(this);
  }

  //DELETE
  //Implementado en la vista borra aquellos desplegables de desplegables
  deleteTipoFormacion(id) {
    let $this = $(this);
    let settings = {
      url: process.env.REACT_APP_API_URL + "/usuarios/" + $this[0].props.DatosUsuario.id + "/estudios/" + $this[0].props.DatosUsuario.datosTipoFormacion.estudios[id].id,
      method: "DELETE",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };
    $.ajax(settings)
      .done(function (response) {
        $this[0].props.setAlert("", "Se ha eliminado correctamente", "success");
        $this[0].props.deleteTipoFormacion(id);
      })
      .fail($this[0].props.ErrorHandling);
  }

  mostrarTipoFormacion() {
    let longitud = 0;
    let TipoFormacion = null;
    let ArrayTipoFormacion = [];
    let study_field = "study_field.type";
    let study_level = "study_level.type";

    if (this.props.DatosUsuario.datosTipoFormacion && this.props.showModalTipoFormacionArray) {
      longitud = this.props.DatosUsuario.datosTipoFormacion.estudios.length;
    }
    for (let i = 0; i < longitud; i++) {
      let Titulacion = null;

      Titulacion = this.props.DatosUsuario.datosTipoFormacion.estudios[i].studyLevelId ? (
        <Col lg="6" className="border">
          <h6>Titulación </h6>
          <p>{this.props.DatosUsuario.datosTipoFormacion.estudios[i][study_level]}</p>
        </Col>
      ) : (
        <Col lg="6" className="border">
          <h6>Horas </h6>
          <p>{this.props.DatosUsuario.datosTipoFormacion.estudios[i].hours}</p>
        </Col>
      );
      TipoFormacion = (
        <Container>
          <Row>
            <Col lg="4" className="border">
              <h6>Campo de Estudio </h6>
              <p>{this.props.DatosUsuario.datosTipoFormacion.estudios[i][study_field]}</p>
            </Col>
            <Col lg="4" className="border">
              <h6>Estudio Realizado </h6>
              <p>{this.props.DatosUsuario.datosTipoFormacion.estudios[i].name}</p>
            </Col>
            <Col lg="4" className="border">
              <h6>Centro </h6>
              <p>{this.props.DatosUsuario.datosTipoFormacion.estudios[i].center}</p>
            </Col>
          </Row>
          <Row>
            <Col lg="6" className="border">
              <h6>Fecha de Término</h6>
              <p>{utils.formatDate(this.props.DatosUsuario.datosTipoFormacion.estudios[i].date)}</p>
            </Col>
            {Titulacion}
          </Row>
        </Container>
      );
      ArrayTipoFormacion.push(
        <Desplegable
          handleButtonShow={this.props.handleButtonShow}
          showModal={this.props.showModalTipoFormacionArray[i]}
          Toogle={this.props.DatosUsuario.datosTipoFormacion.estudios[i]["study_field.type"]}
          value={"2"}
          key={this.props.DatosUsuario.datosTipoFormacion.estudios[i].id}
          id={i}
          Text={TipoFormacion}
          deleteFunction={this.deleteTipoFormacion}
          Form={
            <FormTipoFormacion
              DatosUsuario={this.props.DatosUsuario}
              setTipoFormacion={this.props.setTipoFormacion}
              putTipoFormacion={this.props.putTipoFormacion}
              handleButtonShow={this.props.handleButtonShow}
              id={i}
              setAlert={this.props.setAlert}
            ></FormTipoFormacion>
          }
          canEdit={true}
        />
      );
    }
    if (longitud === 0)
      ArrayTipoFormacion.push(
        <p className="ml-3" key={0}>
          No hay datos actualmente
        </p>
      );
    return ArrayTipoFormacion;
  }

  render() {
    return <React.Fragment>{this.mostrarTipoFormacion()}</React.Fragment>;
  }
}
